import React, { useEffect, useState } from "react";
import "../../Styles/HorizontalBarStyle.css";
import "../../Styles/MultiPurposeStyle.css";

const API_URL = window.__API_URL__;

function PersonGraphBar({ name }) {
  const [data, setData] = useState([]);
  const [mode, setMode] = useState("in"); // "in" = ricevute, "out" = inviate

  useEffect(() => {
    if (!name) return;

    const endpoint =
      mode === "in"
        ? `${API_URL}/person-graph-in/${name}`
        : `${API_URL}/person-graph/${name}`;

    fetch(endpoint)
      .then(res => res.json())
      .then(raw => {
        const formatted = raw.edges.map(e => {
          const label = e.rels?.[0] || "LETTERS: 0";
          const count = parseInt(label.replace("LETTERS: ", "")) || 0;

          return {
            person:
              mode === "in"
                ? raw.nodes.find(n => n.id === e.from)?.label
                : raw.nodes.find(n => n.id === e.to)?.label,
            count
          };
        });

        formatted.sort((a, b) => b.count - a.count);

        setData(mode === "out" ? formatted.slice(0, 20) : formatted);
      })
      .catch(console.error);

  }, [name, mode]);

  if (!name) return null;

  const max = Math.max(...data.map(d => d.count), 1);

  const title =
    mode === "in" ? "Letters received" : "Letters sent";
const buttonLabel =
  mode === "in"
    ? "letters sent"
    : "letters received";
  return (
    <div className="card-container">

      <div className="card-header-legend">

        <h2 className="card-title">
          {title}
        </h2>
         <p className="card-description">place holder 2</p>
        <div className="card-header-buttons">
        <button
        className="horizontal-bar-toggle"
          onClick={() =>
            setMode(prev => (prev === "in" ? "out" : "in"))
          }
        >
        Switch to {buttonLabel}
        </button>

        </div>
      </div>

      <div className="card-wrapper-scroll">

        {data.length === 0 ? (
          <div style={{ color: "#888", fontSize: "14px" }}>
            No data available
          </div>
        ) : (
          data.map((d, i) => (
            <div key={i} className="horizontal-bar-row">

              <div className="horizontal-bar-label">
                {d.person}
              </div>

              <div className="horizontal-bar-track">
                <div
                  className="horizontal-bar-fill"
                  style={{
                    width: `${(d.count / max) * 100}%`,
                    background: "#1890ff"
                  }}
                />
              </div>

              <div className="horizontal-bar-value">
                {d.count}
              </div>

            </div>
          ))
        )}

      </div>
    </div>
  );
}

export default PersonGraphBar;